import React from 'react';
import { withTheme } from 'styled-components';
import { Svg, Rect } from 'react-native-svg';

const Minus = ({ className = '', size = '24px', theme, color = theme.colors['Level 3'] }) => (
    <Svg
        className={className}
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <Rect x="5" y="12" width="14" height="1.84273" rx="0.921364" fill={color} />
    </Svg>
);

export default withTheme(Minus);
